export default {"src":"/_next/static/media/taste-icon.4cd699c2.svg","height":24,"width":24};